import { PASSWORD_REQUIREMENTS } from '../data';

export const checkPasswordStrength = (password) => {
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);
  const hasMinLength = String(password).length >= PASSWORD_REQUIREMENTS.MIN_LENGTH;

  return {
    hasUppercase,
    hasNumber,
    hasSpecial,
    hasMinLength,
    isValid: hasUppercase && hasNumber && hasSpecial && hasMinLength
  };
};
